import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  BEGINNER_PATH_PHASES,
  type BeginnerPathPhase,
} from "../lib/beginnerPath/beginnerPathPlan";
import { isBeginnerPathEntry } from "../lib/beginnerPath/beginnerPathNav";
import type { LevelId } from "../lib/gym/types";

export function useBeginnerPathEntry(): {
  fromPath: boolean;
  phase: BeginnerPathPhase | null;
  gymFocusLevelId: LevelId | null;
} {
  const { search } = useLocation();
  return useMemo(() => {
    const { fromPath, phaseId } = isBeginnerPathEntry(search);
    if (!fromPath || !phaseId) {
      return { fromPath: false, phase: null, gymFocusLevelId: null };
    }
    const phase = BEGINNER_PATH_PHASES.find((p) => p.id === phaseId) ?? null;
    const gymFocusLevelId =
      phase?.id === "guitar-basics" ? ("aprendiz" as LevelId) : null;
    return { fromPath: true, phase, gymFocusLevelId };
  }, [search]);
}
